import { Injectable, Req } from '@nestjs/common';
import { InjectRepository } from '@nestjs/typeorm';
import { Raw, Repository } from 'typeorm';
import { ErrorResponse } from '@gtpl/shared-models/common-models';
import { AllLevelsResponseModel, LevelDropDownResponseModel, LevelDto, LevelResponseModel } from '@gtpl/shared-models/masters';
import { Level } from './level.entity';
import { LevelAdapter } from './dto/level.adapter';
import { LevelDTO } from './dto/level.dto';
import { LevelRequest } from './dto/level.request';
import { LevelDropDownDto } from 'libs/shared-models/masters/src/lib/level/level-drop-down-dto';
import { LevelIdRequest } from './dto/level-id.request';
import { LogsService } from '@gtpl/shared-services/user-logs';
import { LogsDto } from 'libs/shared-models/user-logs/src/lib/Logs/logs.dto';

@Injectable()
export class LevelService {

    constructor(
      private logService:LogsService,

        @InjectRepository(Level) private levelRepository: Repository<Level>,
        private levelAdapter: LevelAdapter,
      ) { }

      async getLevelWithoutRelations(levelName: string): Promise<Level> {
         console.log(levelName);
            const response = await this.levelRepository.findOne({
            where: {levelName: Raw(alias => `level_name = '${levelName}'`)},
            });
            console.log(response);
            if (response) {
            return response;
            } else {
            return null;
            }
        }

      async createLevel(levelDto:LevelDTO,isUpdate:boolean=false,@Req() request:Request): Promise<LevelResponseModel> {
        try {
        
        if (!isUpdate) {
            const levelEntity = await this.getLevelWithoutRelations(levelDto.levelName);
          if (levelEntity) {
            throw new LevelResponseModel(false,11104, 'Level already exists');
          }
        }else{
            const levelEntity = await this.getLevelWithoutRelationsForUpdate(levelDto.levelCode,levelDto.levelName,levelDto.levelId);
            if(levelEntity){
                if(levelEntity.levelId!=levelDto.levelId) {
                    throw new LevelResponseModel(false,11104, 'Level already exists');      
                }
            }
        }
        // else{
        //     const levelEntity = await this.getLevelWithoutRelations(levelDto.levelName);
        //     if(levelEntity){
        //         if(levelEntity.levelId!=levelDto.levelId) {
        //             throw new LevelResponseModel(false,11104, 'level already exists');      
        //         }
        //     }
        // }
        const levelEntity: Level = this.levelAdapter.convertDtoToEntity(levelDto,isUpdate);
        const savedLevelEntity: Level = await this.levelRepository.save(levelEntity);
        const savedLevelDto: LevelDTO = this.levelAdapter.convertEntityToDto(savedLevelEntity);
       
         if (savedLevelEntity) {
          const response = new LevelResponseModel(true,isUpdate ? 11100 : 11101,isUpdate? 'Level Updated Successfully':'Level Created Successfully',savedLevelDto);
          const name=isUpdate?'updated':'created'
            const newLogDto = new LogsDto(1,name, 'Level', savedLevelEntity.levelId, true, '',savedLevelEntity.createdUser)
            let res = await this.logService.createLog(newLogDto);
            console.log(res);
          return response;
        } else {
          throw new LevelResponseModel(false,11106,'Level saved but issue while transforming into DTO');
        }
      }
      catch (error) {
        return error;
      }
    }

    async getAllLevels(): Promise<AllLevelsResponseModel> { 
        try {
            const levelDto: LevelDto[] = [];
            // retrieves all plants
            const levelEntities: Level[] = await this.levelRepository.find({
                order: { levelName: "ASC" },
            });
            if (levelEntities.length>0) {
                levelEntities.forEach(levelEntity => {
                const convertedLevelDto: LevelDto = this.levelAdapter.convertEntityToDto(levelEntity);
                levelDto.push(convertedLevelDto);
                });
                const response = new AllLevelsResponseModel(true, 11208, "Level retrieved successfully", levelDto);
                const newLogDto = new LogsDto(1,'view', 'Level', 0, true, '','')
            let res = await this.logService.createLog(newLogDto);
            console.log(res);
                return response;
            } else {
                throw new LevelResponseModel(false,99998, 'No Records Found');
            }
        } catch (err) {
            throw err;
        }
    }

    async getLevelByLevelId(levelIdRequest:LevelIdRequest): Promise<LevelResponseModel> { 
        try {
            const levelDto: LevelDto[] = [];
            // retrieves all plants
            const levelEntities = await this.levelRepository.findOne({
                where: { levelId:levelIdRequest.levelId },
            });
            if (levelEntities) {
                
                const convertedLevelDto = this.levelAdapter.convertEntityToDto(levelEntities);
               
                const response = new LevelResponseModel(true, 11208, "Level retrieved successfully", convertedLevelDto);
                return response;
            } else {
                throw new LevelResponseModel(false,99998, 'No Records Found');
            }
        } catch (err) {
            throw err;
        }
    }

    async activateOrDeactivateLevel(levelReq: LevelRequest): Promise<LevelResponseModel> {
        try {
            const levelExists = await this.getLevelById(levelReq.levelId);
            if (levelExists) {
                if (levelReq.versionFlag !== levelExists.versionFlag) {
                    throw new LevelResponseModel(false,10113, 'Someone updated the current level information.Refresh and try again');
                } else {
                    
                        const levelStatus =  await this.levelRepository.update(
                            { levelId: levelReq.levelId },
                            { isActive: levelReq.isActive,updatedUser: levelReq.updatedUser });
                       
                        if (levelExists.isActive) {
                            if (levelStatus.affected) {
                                const levelResponse: LevelResponseModel = new LevelResponseModel(true, 10115, 'Level is de-activated successfully');
                                return levelResponse;
                            } else {
                                throw new LevelResponseModel(false,10111, 'Level is already deactivated');
                            }
                        } else {
                            if (levelStatus.affected) {
                                const levelResponse: LevelResponseModel = new LevelResponseModel(true, 10114, 'Level is activated successfully');
                                return levelResponse;
                            } else {
                                throw new LevelResponseModel(false,10112, 'level is already  activated');
                            }
                        }
                    // }
                }
            } else {
                throw new LevelResponseModel(false,99998, 'No Records Found');
            }
        } catch (err) {
            throw err;
        }
    }

    async getLevelById(levelId: number): Promise<Level> {
        //  console.log(employeeId);
            const Response = await this.levelRepository.findOne({
            where: {levelId: levelId},
            });
            // console.log(employeeResponse);
            if (Response) {
            return Response;
            } else {
            return null;
            }
        }

        async getAllLevelDropDown(): Promise<LevelDropDownResponseModel> {
            try {
                const levelDto: LevelDropDownDto[] = [];
                const levelEntities: Level[] = await this.levelRepository.find({ select: ['levelId', 'levelName'], where: { isActive: true }})
    
    
                if (levelEntities && levelEntities.length > 0) {
                    levelEntities.forEach(rackEntity => {
                        levelDto.push(new LevelDropDownDto(rackEntity.levelId,rackEntity.levelName));
                    });
                    const response = new LevelDropDownResponseModel(true, 11108, "level retrieved successfully", levelDto);
                    return response;
                } else {
                    throw new LevelResponseModel(false,99998, 'Data not found');
                }
            } catch (err) {
                throw err;
            }
        }
    
        async getLevelWithoutRelationsForUpdate(levelCode:string,levelName: string,id:number): Promise<Level> {
            const responseCode = await this.levelRepository.findOne({
                where: { levelCode: levelCode },
            });
            const responseNo = await this.levelRepository.findOne({
                where: {levelName: levelName },
            });
            if (responseCode || responseNo) {
                if(responseCode && responseNo){
                    if(responseCode.levelId == responseNo.levelId){
                        return responseCode;
                    }
                    else if( responseCode.levelId == id){
                        return responseNo;
                    }
                    else if( responseNo.levelId == id){
                        return responseCode;
                    }
                    else{
                        return responseCode;
                    }
                }
                else if(responseCode && !responseNo){
                    return responseCode;
                }
                else if(responseNo && !responseCode){
                    return responseNo;
                }
            } else {
                return null;
            }
           }


}
